import React from 'react'

import englishGlobal from '../translations/en.global.json'
import { Translate } from '../common/Translate'

export const translateChecker = (id, data, subField) => {

    const allTranslations = Object.assign({}, englishGlobal)
    return ((subField && (allTranslations[subField].hasOwnProperty(id))) || allTranslations.hasOwnProperty(id)
        ? (data ? <Translate id={ subField ? `${subField}.${id}` : id} data={data}/> 
        : <Translate id={ subField ? `${subField}.${id}` : id}/>) : id)
}